<template>
  <div>
    <h3 class="title-page">{{ $t("customer") }}</h3>
    <div class="reference_type_page">
      <div class="admin_container">
        <v-btn
          @click="editItem('add')"
          color="primary"
          style="display: block"
          dark
          class="ml-auto mb-5"
        >
          {{ $t("create") }}
        </v-btn>
        <table-with-filter
          :headers="headers"
          :items="customers"
          hide-default-footer
          sort-by="calories"
          class="elevation-1"
          id="user_table_item"
        >
          <template #filter.name>
            <div class="pa-1">
              <custom-input-text
                class="user_input no-margin"
                v-model="configuration.name"
                @input="getItemsByName(configuration.name)"
              />
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="editItem('update', item)"
                >
                  <vue-icon icon="newPencilIcon" />
                </v-btn>
              </template>
              <span>{{ $t("edit") }}</span>
            </v-tooltip>
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="editItem('delete', item)"
                >
                  <vue-icon icon="newTrashIcon" />
                </v-btn>
              </template>
              <span>{{ $t("delete") }}</span>
            </v-tooltip>
          </template>
        </table-with-filter>
        <v-pagination
          :total-visible="10"
          v-if="configuration.lastPage > 1"
          @input="changePage"
          v-model="configuration.page"
          :length="configuration.lastPage"
        ></v-pagination>
      </div>

      <!--        modals-->
      <v-dialog v-model="dialog" max-width="500px">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <v-form @submit.prevent="handleSubmit(save)">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
                <v-icon @click="dialog = false" class="info_modal_close"
                  >mdi-close
                </v-icon>
              </v-card-title>

              <v-card-text>
                <div class="edit_user_table">
                  <CustomInputText
                    rules="required"
                    v-model="editedItem.name"
                    :label="$t('name') + '*'"
                  ></CustomInputText>
                </div>
              </v-card-text>

              <v-card-actions class="footer_modal_user">
                <v-spacer></v-spacer>
                <v-btn color="#9EABBE" dark @click="close">{{
                  $t("toCancel")
                }}</v-btn>
                <v-btn color="primary" dark type="submit">{{
                  $t("save")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </ValidationObserver>
      </v-dialog>
      <warning-dialog
        v-model="deleteModal"
        @apply="deleteItem"
      ></warning-dialog>
    </div>
  </div>
</template>

<script>
import WarningDialog from "../../../components/ui/prompt/warning-dialog";
import { debounce, makerPagination } from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";

export default {
  components: { TableWithFilter, WarningDialog },
  data: () => ({
    dialog: false,
    deleteModal: false,
    customers: [],
    editedItem: {
      name: "",
    },
    configuration: {
      total: 0,
      limit: 10,
      page: 1,
      lastPage: 0,
    },
  }),

  computed: {
    headers() {
      return [
        {
          text: "№",
          value: "index",
        },
        {
          text: this.$t("nameOfCustomer"),
          value: "name",
        },
        { text: "", value: "actions", sortable: false },
      ];
    },
    formTitle() {
      return this.editedItemId ? this.$t("editGroup") : this.$t("create");
    },
    editedItemId() {
      return this.editedItem.id;
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        const { form } = this.$refs;
        this.editedItem = {
          name: "",
        };
        if (form) form.reset();
      }
    },
    deleteModal(val) {
      if (!val) {
        this.clearModal();
      }
    },
  },
  methods: {
    clearModal() {
      this.editedItem = {
        name: "",
      };
    },
    editItem(type, item) {
      switch (type) {
        case "add":
          this.dialog = true;
          break;
        case "update":
          this.editedItem = { ...item };
          this.dialog = true;
          break;
        case "delete":
          this.editedItem = item;
          this.deleteModal = true;
          break;
      }
    },

    close() {
      this.dialog = false;
    },

    async deleteItem() {
      try {
        const { id } = this.editedItem;
        await this.$http.delete("customer/delete", { params: { id } });
        this.setSuccess({ text: this.$t("successfullyDeleted") });
        await this.getItems();
      } catch (e) {
        this.setResponseError({
          error: e,
        });
      }
    },
    async save() {
      try {
        this.showLoading();
        await this.$http.post("customer/save", null, {
          params: this.editedItem,
        });
        await this.getItems();
        this.dialog = false;
        this.clearModal();
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async changePage(val) {
      const { page } = this.$route.query;
      if (val.toString() !== page) {
        await this.$router.push({ query: { page: val } });
        this.configuration.page = val;
        this.showLoading();
        await this.getItems();
        this.clearLoading();
      }
    },
    getItemsByName: debounce(async function (name) {
      this.showLoading();
      if (this.configuration.page !== 1) {
        this.configuration.page = 1;
        await this.$router.replace({ query: { page: "1" } });
      }
      await this.getItems(name);
      this.clearLoading();
    }, 300),
    async getItems() {
      try {
        const { page, limit, name } = this.configuration;
        const params = {
          page: page - 1,
          limit,
        };
        if (name) {
          params.name = name;
        }
        const {
          data: { data, total },
        } = await this.$http.get("/customer/list", {
          params,
        });
        this.configuration.lastPage = makerPagination({
          total,
          limit,
        }).lastPage;
        this.customers = data.map((item, index) => {
          item.index = limit * (page - 1) + index + 1;
          return item;
        });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  async created() {
    this.showLoading();
    const { page } = this.$route.query;
    if (page) {
      this.configuration.page = +page;
    }
    await this.getItems();
    this.clearLoading();
  },
};
</script>

<style scoped></style>
